export const messages = {
  en: {
    dataReport: {
      timeRange: 'Time Range',
      startDate: 'Start Date',
      endDate: 'End Date',
      to: 'to',
      selectCommunity: 'Select Community',
      today: 'Today',
      yesterday: 'Yesterday',
      last7Days: 'Last 7 Days',
      last30Days: 'Last 30 Days',
      feeStatistics: 'Fee Statistics',
      orderStatistics: 'Order Statistics',
      inoutStatistics: 'In/Out Statistics',
      otherStatistics: 'Other Statistics',
      building: 'Building',
      roomCount: 'Room Count',
      feeRoomCount: 'Fee Room Count',
      receivedFee: 'Received Fee',
      totalReceived: 'Total Received',
      export: 'Export',
      roomNumber: 'Room Number',
      ownerName: 'Owner Name',
      phoneNumber: 'Phone Number',
      search: 'Search',
      reset: 'Reset',
      room: 'Room',
      owner: 'Owner',
      oweFee: 'Owe Fee',
      totalOwe: 'Total Owe',
      historyOwe: 'History Owe',
      todayPaidCount: 'Today Paid Count',
      todayPaidAmount: 'Today Paid Amount',
      historyPaidCount: 'History Paid Count',
      historyPaidAmount: 'History Paid Amount',
      monthPaidCount: 'Month Paid Count',
      remainingCount: 'Remaining Count',
      paidRatio: 'Paid Ratio',
      monthPaidAmount: 'Month Paid Amount',
      monthRemaining: 'Month Remaining',
      collectionRate: 'Collection Rate',
      feeName: 'Fee Name',
      receivedPeriod: 'Received Period',
      cashier: 'Cashier',
      paymentTime: 'Payment Time',
      owePeriod: 'Owe Period',
      oweAmount: 'Owe Amount',
      receivedAmount: 'Received Amount',
      selectBuilding: 'Select Building',
      feeStartDate: 'Fee Start Date',
      feeEndDate: 'Fee End Date',
      noExportData: 'No data to export'
    }
  },
  zh: {
    dataReport: {
      timeRange: '统计时间',
      startDate: '开始日期',
      endDate: '结束日期',
      to: '至',
      selectCommunity: '请选择园区',
      today: '今日',
      yesterday: '昨日',
      last7Days: '近7日',
      last30Days: '近30日',
      feeStatistics: '费用类统计',
      orderStatistics: '工单类统计',
      inoutStatistics: '出入统计',
      otherStatistics: '其他统计',
      building: '楼栋',
      roomCount: '户数',
      feeRoomCount: '收费户数',
      receivedFee: '实收',
      totalReceived: '总实收',
      export: '导出',
      roomNumber: '房屋编号',
      ownerName: '业主名称',
      phoneNumber: '手机号',
      search: '查询',
      reset: '重置',
      room: '房屋',
      owner: '业主',
      oweFee: '欠费',
      totalOwe: '总欠费',
      historyOwe: '历史欠费',
      todayPaidCount: '本日已交户数',
      todayPaidAmount: '本日已交金额',
      historyPaidCount: '历史欠费清缴户',
      historyPaidAmount: '历史欠费清缴金额',
      monthPaidCount: '本月已收户数',
      remainingCount: '剩余户数',
      paidRatio: '已收户占比',
      monthPaidAmount: '当月已收金额',
      monthRemaining: '当月剩余未收',
      collectionRate: '收费率',
      feeName: '费用名称',
      receivedPeriod: '实收时间段',
      cashier: '收银员',
      paymentTime: '交费时间',
      owePeriod: '欠费时间段',
      oweAmount: '欠费金额',
      receivedAmount: '实收',
      selectBuilding: '请选择楼栋',
      feeStartDate: '费用开始时间',
      feeEndDate: '费用结束时间',
noExportData: '沒有可以導出的數據'
    }
  },
  'zh-TW': {
    dataReport: {
      timeRange: '統計時間',
      startDate: '開始日期',
      endDate: '結束日期',
      to: '至',
      selectCommunity: '請選擇小區',
      today: '今日',
      yesterday: '昨日',
      last7Days: '近7日',
      last30Days: '近30日',
      feeStatistics: '費用類統計',
      orderStatistics: '工單類統計',
      inoutStatistics: '出入統計',
      otherStatistics: '其他統計',
      building: '樓棟',
      roomCount: '戶數',
      feeRoomCount: '收費戶數',
      receivedFee: '實收',
      totalReceived: '總實收',
      export: '匯出',
      roomNumber: '房屋編號',
      ownerName: '業主名稱',
      phoneNumber: '手機號',
      search: '查詢',
      reset: '重置',
      room: '房屋',
      owner: '業主',
      oweFee: '欠費',
      totalOwe: '總欠費',
      historyOwe: '歷史欠費',
      todayPaidCount: '本日已交戶數',
      todayPaidAmount: '本日已交金額',
      historyPaidCount: '歷史欠費清繳戶',
      historyPaidAmount: '歷史欠費清繳金額',
      monthPaidCount: '本月已收戶數',
      remainingCount: '剩餘戶數',
      paidRatio: '已收戶占比',
      monthPaidAmount: '當月已收金額',
      monthRemaining: '當月剩餘未收',
      collectionRate: '收費率',
      feeName: '費用名稱',
      receivedPeriod: '實收時間段',
      cashier: '收銀員',
      paymentTime: '交費時間',
      owePeriod: '欠費時間段',
      oweAmount: '欠費金額',
      receivedAmount: '實收',
      selectBuilding: '請選擇樓棟',
      feeStartDate: '費用開始時間',
      feeEndDate: '費用結束時間',
      noExportData: '沒有可以導出的數據'
    }
  }
}